import { FC, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryParam } from '@datassential/platform-ui-lib';
import { useCountrySwitch } from '@hooks/useCountrySwitch';
import { CHAIN_NAME_PARAM, COUNTRY_ID_PARAM, CountryId } from '@core/constants';
import { Route } from '@core/routes/Route';
import { useFiltersContext } from '@core/FiltersContext';
import { FiltersVariant } from '@models/Filter';

const ChainLaunches: FC = () => {
    const history = useNavigate();

    const chainName = useQueryParam(CHAIN_NAME_PARAM);
    const countryId = useQueryParam(COUNTRY_ID_PARAM) || CountryId.USA;

    const { shouldSwitchCountry, switchCountry } = useCountrySwitch();
    const { isLoaded, updateSpecificValueByChainName } = useFiltersContext();

    const launchChain = useCallback(() => {
        if (shouldSwitchCountry(countryId)) {
            switchCountry(countryId);
        } else {
            updateSpecificValueByChainName(FiltersVariant.Homepage, chainName);
            history(Route.Home);
        }
    }, [chainName, countryId, shouldSwitchCountry, history, updateSpecificValueByChainName, switchCountry]);

    useEffect(() => {
        if (!chainName || !isLoaded) return;
        
        launchChain();
    }, [chainName, isLoaded, launchChain]);
    
    return null;
};

export default ChainLaunches;
